import * as Yup from 'yup';

export default Yup.object().shape({
  billingZipCode: Yup.string()
    .matches(/^[0-9]{5}$/, 'SCHEMA_ERRORS.ZIP_CODE_INVALID')
    .required('SCHEMA_ERRORS.CLIENT_DETAIL_FORM.ZIP_CODE_INVALID')
});
